import { Component, OnInit, ViewChild } from '@angular/core';
import {NgForm} from '@angular/forms';
import { SelectItem } from 'primeng/api';
import {Validators,FormControl,FormGroup,FormBuilder} from '@angular/forms';
import { countries } from 'src/app/Component/questionnaire/country-list';
import {RestApiService} from '../../Services/rest-api-service';
import { Questionnaire } from 'src/app/Model/apilist-model';

@Component({
  selector: 'app-payer-questionnaire',
  templateUrl: './payer-questionnaire.component.html'
})
export class PayerQuestionnaireComponent implements OnInit {

  //payerQuestionnaireForm : FormGroup;

  //securitypractices: SelectItem[];
  //review: SelectItem[];
  //consent: SelectItem[];
  userValues: any = {};
  countries: any = countries;
  MultipleRequest:any[]=[];
  showMsg: boolean = false;
  contactArray = false;
  duplicateContacts = false;

  firstName;
  lastName;
  emailId;
  reamrks_soft;
  contactName: String;
  email: String;
  contactBusinessEmailText:String;
  telephone: String;
  countryCode:String;
  newObject : any[]=[];
  payerName: String;
  parentCompanyname: String;
  registrantName: String;
  registrantRole: String;
  storagecountry:string;
  domainlist: String;
  securitypractices:boolean;
  review:boolean;
  consent:boolean;
  FHIRStandards: String;
  showSpiner=false;
  number : Number;
  rowData;
  submitted = false;
  payerStatus_qu;

  @ViewChild('multipleContact', {static: false}) multipleContact: NgForm;
  @ViewChild('payerQuestionnaireForm', {static: false}) payerQuestionnaireForm: NgForm;
  //securityPracticesResponse: String;
  //review_response: String;
  //consent_response: String;


  firstNameDisplay;
  lastNameDisplay;
  emailIdDisplay; 
 
  constructor( private restApi: RestApiService) {

    this.firstName= localStorage.getItem("firstName");
    this.lastName= localStorage.getItem("lastName");
    this.emailId= localStorage.getItem("email_ID");

    this.firstNameDisplay=localStorage.getItem("firstName");
    this.lastNameDisplay=localStorage.getItem("lastName");
    this.emailIdDisplay=localStorage.getItem("email_ID"); 

    this.payerStatus_qu =localStorage.getItem("payerStatus_qu");
    /* this.securitypractices = [
      { label: 'Yes', value: 'null' },
      { label: 'No', value: 'null' }
    ]; */
    /* this.review = [
      { label: 'Yes', value: 'null' },
      { label: 'No', value: 'null' }
    ];
    this.consent = [
      { label: 'Yes', value: 'null' },
      { label: 'No', value: 'null' }
    ]; */

   
    const sortArrayObjs = function(arr, prop1, prop2) {
      let sort1 = [...arr].sort((a, b) => {
        if (a[prop1] == b[prop1]) {
          if (a[prop2] === b[prop2]) return 0;
          return (a[prop2] < b[prop2]) ? -1 : 1;
        } else {
          return (a[prop1] < b[prop1]) ? -1 : 1;
        }
      });
      return sort1;
    };


this.countries  = sortArrayObjs(this.countries, 'name', 'number');


  }
  deleteRow(data:any){
    const index: number = this.newObject.indexOf(data);
    if (index !== -1) {
        this.newObject.splice(index, 1);
    } 
    this.number = this.newObject.length
    console.log(this.number);
    if(this.number == 0){
      console.log("All rows deleted")
      this.DisplayMultipleRequest=false;
    }
  }
 
 /*  deleteRow(i){
    console.log("under delete method");
    console.log(i);
    //this.rowData.splice(i, 1);
    this.MultipleRequest.splice(i, 1);
    //let number = this.newObject.length
    this.number = this.newObject.length
    console.log(this.number);
    if(this.number == 0){
      console.log("All rows deleted")
      this.DisplayMultipleRequest=false;
    }
  } */

  getCountryCodeValue(code){

    for(let cnt of this.countries){
   
       if(code==cnt.code3){
        return cnt.number;
       }

    }
}

getCountryCodeByValue(value){

    if(value=='1' || value==1){

      return 'USA';
    }
  for(let cnt of this.countries){
 
     if(value==cnt.number){
      return cnt.code3;
     }

  }
}


 
  editContact(Data : any){
    console.log("under edit method");
    
    console.log(Data)
    //console.log("contactName: ", Data.contactName);
    this.userValues.contactName = Data.contactName;
    this.userValues.email = Data.contactBusinessEmailText;
    
    let countryValue=this.getCountryCodeByValue(Data.countryCode);
  
   
    
    this.userValues.countryCode = countryValue;


    this.userValues.telephone = Data.contactTelephoneNumber;


    const index: number = this.newObject.indexOf(Data);
    if (index !== -1) {
        this.newObject.splice(index, 1);
    }
    this.number = this.newObject.length
    console.log(this.number);
    if(this.number == 0){
      console.log("All rows deleted")
      this.DisplayMultipleRequest=false;
    }

  }

  onSubmit(){

    let securityReview:boolean=false;
    let regReview:boolean=false;
    let userConstent:boolean=false;
  
    if(this.userValues.securitypractices=='Yes'){
      securityReview=true;
      //console.log(this.userValues.securitypractices);
      //console.log(securityReview);
    }
    
    if(this.userValues.review=='Yes'){
      regReview=true;
    }

    if(this.userValues.consent=='Yes'){
      userConstent=true;
    } 


   let number = this.newObject.length
    console.log(number);
    if(number == 0){
      console.log("please add atleast one contact");
      //this.DisplayMultipleRequest=false;
      this.contactArray = true;
      return true;

    }  
      
    localStorage.setItem("questionnaireTypeCode_n","PAYER");

    let registrantName=this.firstName+" "+this.lastName; 
  //console.log(this.userValues);
  //[{"contactName": this.userValues.contactName.trim(),"contactBusinessEmailText":this.userValues.email.trim(), "countryCode": this.userValues.countryCode, "contactTelephoneNumber": this.userValues.telephone}]
  this.showSpiner=true;
  const requestJSON={"contact": this.newObject, "emailIdentifier": localStorage.getItem("email_ID"),
                     "payerDataText": this.userValues.FHIRStandards.trim(),
                     "orgCountryCode": this.userValues.country, 
                     "orgName": this.userValues.payerName.trim(),
                     "parentOrgName": this.userValues.parentCompanyname,
                     "registrantName": registrantName,"roleName": this.userValues.registrantRole.trim(),
                     "phiDataText": this.userValues.storagecountry,"domainName": this.userValues.domainlist.trim(),
                     "securityPracticesIndicator": securityReview, "regularlyReviewedIndicator": regReview,
                     "userConsentIndicator": userConstent, "deletionFlagCode":false,"firstName":localStorage.getItem("firstName"),"lastName":localStorage.getItem("lastName"),"status":"Submitted","questionnaireTypeCode":'PAYER',"questionnaireStatusText":"","lastUpdateUserIdentifier":localStorage.getItem("email_ID")
                      
                      };
console.log(requestJSON);

this.restApi.ThirdPartyDevQuestionnaire_PostRequest(requestJSON).subscribe(
(data)=>{
    //console.log(data);
    //this.showMsg= true;
    this.submitted = true;
    this.showSpiner=false;
    //this.showMsg= true;
    // this.userValues={};

    localStorage.setItem("payerStatus_qu","");

    window.scroll(0,0);

    this.payerQuestionnaireForm.resetForm();

  },
    (error)=>{
  
        this.showSpiner=false;
  }) 

}
  DisplayMultipleRequest=false;
  public addMultipleRequest(){



    let emailDomain=this.userValues.email.toLowerCase().trim();
    let phoneNumberValid=this.userValues.telephone;

    if(emailDomain.includes('gmail')
    ||emailDomain.includes('outlook.com')
    ||emailDomain.includes('live.com')
    ||emailDomain.includes('yahoo.com')
    ||emailDomain.includes('aol.com')
    ||emailDomain.includes('proton.me')
    ||emailDomain.includes('protonmail.com')
    ||emailDomain.includes('pm.me')
    ||emailDomain.includes('protonmail.ch')
    ||emailDomain.includes('gmx.net')
    ||emailDomain.includes('gmx.com')
    ||emailDomain.includes('icloud.com')
    ||emailDomain.includes('tutamail.com')
    ||emailDomain.includes('tuta.io')
    ||emailDomain.includes('tutanota.com')
    ||emailDomain.includes('tutanota.de')
    ||emailDomain.includes('keemail.me')
    ||emailDomain.includes('10minutemail.net')
    ||emailDomain.includes('juno.com')
    ||emailDomain.includes('mailsac.com')){

      const str = emailDomain;
      const slug = str.split('@').pop();
 
       alert(slug+" accounts are not allowed. Please enter a valid business email ID.")
 
      return true;
    }

    if(phoneNumberValid=='0000000000' || phoneNumberValid=='1111111111'){

      alert("Please enter a valid telephone number.")
      return true;
    }




    for(let contact of this.MultipleRequest){

      let email=contact.contactBusinessEmailText;
      let phoneNumber=contact.contactTelephoneNumber;

      console.log("email is "+email)
      console.log("phoneNumber is "+phoneNumber)
  
      let emailAdded=this.userValues.email.trim();
      let phoneNumberAdded=this.userValues.telephone;

       console.log("email is Added"+emailAdded)
       console.log("phoneNumber is Added"+phoneNumberAdded)
  
         if(emailAdded==email){
           window.alert("It is not permitted to use the same Contact Business Email for multiple contacts.");
         
            return true;
         }
         if(phoneNumber==phoneNumberAdded){
          window.alert("It is not permitted to use the same Telephone Number for multiple contacts.");
          return true;
        }



     }



    this.contactArray = false;
    
    this.DisplayMultipleRequest=true;
    let countyCodeValue=this.getCountryCodeValue(this.userValues.countryCode);


    this.MultipleRequest.push({contactName: this.userValues.contactName.trim() ,contactBusinessEmailText: this.userValues.email.trim() ,countryCode: countyCodeValue , contactTelephoneNumber: this.userValues.telephone})  
    this.newObject = this.MultipleRequest
    console.log(this.newObject);
    this.multipleContact.resetForm();
  }
  
/* DisplayMultipleRequest=false;
public addMultipleRequest(){
  this.contactArray = false;
  
  this.DisplayMultipleRequest=true;
  
  //console.log("under add method")
  this.MultipleRequest.push({contactName: this.userValues.contactName.trim() ,contactBusinessEmailText: this.userValues.email.trim() ,countryCode: this.userValues.countryCode , contactTelephoneNumber: this.userValues.telephone})
  var arrayLength = this.MultipleRequest.length; 
  console.log(arrayLength);
  if (arrayLength > 0) { 
    var firstA = this.MultipleRequest[0].contactName; 
    //console.log(firstA);
    var firstB = this.MultipleRequest[0].contactBusinessEmailText;
    //console.log(firstB);
    var firstC = this.MultipleRequest[0].countryCode;
    //console.log(firstC);
    var firstD = this.MultipleRequest[0].contactTelephoneNumber;
    //console.log(firstD);
    for(var i = 1; i<arrayLength; i++) {
      //console.log("under for loop")
        //if the new one doesn't match the first one, break out
        if (firstA == this.MultipleRequest[i].contactName && firstB == this.MultipleRequest[i].contactBusinessEmailText && firstC == this.MultipleRequest[i].countryCode && firstD == this.MultipleRequest[i].contactTelephoneNumber) 
            {
                //return false;
                this.duplicateContacts = true;
                this.MultipleRequest.splice(-1);
            }     
    }
     //return true;    
  } 
  this.newObject = this.MultipleRequest
  console.log(this.newObject);
  this.multipleContact.resetForm();
}  */

 
  

 


  ngOnInit() {
    /* this.payerQuestionnaireForm = new FormGroup({
      'payerName' : new FormControl(null, Validators.required)
    });
 */

          if(this.payerStatus_qu=='4' || this.payerStatus_qu=='11'){
            this.getQuestionerData();
          }



  }


  getQuestionerData(){
    //console.log(this.userValues);
  
    this.restApi.getQuestionnireData().subscribe(
      (data)=>{
  
        let questionireList=data as Questionnaire[];
  
        for(let ques of  questionireList)
        {
         
         
           if(ques.questionnaireTypeCode.trim()=='PAYER'){
  
             
              this.userValues.country=ques.orgCountryCode;
              this.userValues.payerName=ques.orgName;
              this.userValues.role=ques.roleName;
              this.userValues.storagecountry=ques.phiDataText;
              this.userValues.appName=ques.payerDataText;
              this.userValues.domainlist=ques.domainName;
               this.userValues.parentCompanyname=ques.parentOrgName;
               this.userValues.registrantName=ques.registrantName;
              this.reamrks_soft=ques.remarkText;
              this.userValues.registrantRole=ques.roleName;
              this.userValues.FHIRStandards=ques.payerDataText;  
              this.userValues.parentCompanyname=ques.parentOrgName;    

              let securityReview:boolean=false;
              let userConstent:boolean=false;
              let regReview:boolean=false;
            
              if(ques.securityPracticesIndicator){
                this.userValues.securitypractices='Yes';
              
              }else{
  
                this.userValues.securitypractices='No';
              }
            
              if(ques.userConsentIndicator){
                this.userValues.consent='Yes';
              }else{
                this.userValues.consent='No';
              }
              
              if(ques.regularlyReviewedIndicator){
                this.userValues.review='Yes';
              }else{
                this.userValues.review='No'; 
              }
            
              this.firstName= ques.registrantName.substring(0, ques.registrantName.indexOf(' ')); // "72"
              this.lastName= ques.registrantName.substring(ques.registrantName.indexOf(' ') + 1);
            


              for(let con of  ques.contact)
              {

               

               

                this.addMultipleRequestGET(con);
               
                     
                     
              }
  
            }//end of IF loop
  
        }//end of for loop
  
      },
      (error)=>{
    
       
    })
      
  }
  


  public addMultipleRequestGET(data:any){
    
    this.DisplayMultipleRequest=true;
    this.MultipleRequest.push({contactName: data.contactName.trim() ,contactBusinessEmailText: data.contactBusinessEmailText.trim() ,countryCode: data.countryCode.trim() , contactTelephoneNumber: data.contactTelephoneNumber})  
    this.newObject = this.MultipleRequest
   // console.log(this.newObject);
   // this.multipleContact.resetForm();
  }







  ngAfterViewInit() {
    // Hack: Scrolls to top of Page after page view initialized
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }
  }

}



